import type { Questionnaire } from '@medplum/fhirtypes'
import { SENSITIVE_QUESTIONNAIRE_ITEM } from '#src/codeSystems.ts'

export const AdditionalInformationQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/demographics-information',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Additional Information Demographics',
  title: 'Additional Information',
  item: [
    {
      linkId: 'details',
      text: 'Details',
      type: 'text',
    },
    {
      linkId: 'ssn',
      text: 'SSN',
      type: 'string',
      extension: [
        {
          url: SENSITIVE_QUESTIONNAIRE_ITEM,
          valueBoolean: true,
        },
      ],
    },
    {
      linkId: 'header-note',
      text: 'Header Note',
      type: 'text',
    },
    {
      linkId: 'contact-note',
      text: 'Contact Note',
      type: 'text',
    },
  ] as const,
} satisfies Questionnaire
